<ul role="menubar">
  @for (menuItem of sidebarMenuService.menuItems; track menuItem.id) {
    <li role="none">
      <!-- parent menu (with children) -->
      @if (menuItem.type === 'P') {
        <ng-container [ngTemplateOutlet]="parent"
                      [ngTemplateOutletContext]="{parentMenu: menuItem}">
        </ng-container>
      }
      <!-- main menu (no children) -->
      @if (menuItem.type === 'M') {
        <ng-container>
          <!-- RouterLink Menu-Item -->
          @if (menuItem?.routerLink) {
            <a class="sidebar-menu-link"
               role="menuitem"
               [id]="menuItem.id"
               [routerLink]="menuItem?.routerLink"
               [ngClass]="menuItem.active ? 'active-main-menu' : null"
               [class.selected]="menuItem?.selected"
               (click)="activateMenuItem(menuItem)"
               (keydown)="onKeyDown($event)"
               [pTooltip]="!menuItem.i18nLabelKey ? menuItem.label : i18n?.i18nLng()[menuItem.i18nLabelKey]">
              <i [ngClass]="menuItem.icon"></i>
              @if (!menuItem.i18nLabelKey) {
                <span class="label" [class.visible]="layoutService.menuExpanded()">{{ menuItem.label }}</span>
              } @else {
                <span class="label" [class.visible]="layoutService.menuExpanded()">{{ i18n?.i18nLng()[menuItem.i18nLabelKey] }}</span>
              }
            </a>
          }
          <!-- URI Menu-Item -->
          @if (menuItem?.url) {
            <a class="sidebar-menu-link"
               role="menuitem"
               [id]="menuItem.id"
               [href]="menuItem?.url"
               [target]="menuItem?.target ? menuItem?.target : null"
               [ngClass]="menuItem.active ? 'active-main-menu' : null"
               [class.selected]="menuItem?.selected"
               (click)="activateMenuItem(menuItem)"
               (keydown)="onKeyDown($event)"
               [pTooltip]="!menuItem.i18nLabelKey ? menuItem.label : i18n?.i18nLng()[menuItem.i18nLabelKey]">
              <i [ngClass]="menuItem.icon"></i>
              @if (!menuItem.i18nLabelKey) {
                <span class="label" [class.visible]="layoutService.menuExpanded()">{{ menuItem.label }}</span>
              } @else {
                <span class="label" [class.visible]="layoutService.menuExpanded()">{{ i18n?.i18nLng()[menuItem.i18nLabelKey] }    }</span>
              }
            </a>
          }
          <!-- else... -->
          @if (!menuItem?.routerLink && !menuItem?.url) {
            <a class="sidebar-menu-link"
               role="menuitem"
               [id]="menuItem.id"
               tabindex="0"
               [routerLink]="menuItem?.routerLink ? menuItem.routerLink : null"
               [ngClass]="menuItem.active ? 'active-main-menu' : null"
               [class.selected]="menuItem?.selected"
               (click)="activateMenuItem(menuItem)"
               (keydown)="onKeyDown($event)"
               [pTooltip]="!menuItem.i18nLabelKey ? menuItem.label : i18n?.i18nLng()[menuItem.i18nLabelKey]">
              <i [ngClass]="menuItem.icon"></i>
              @if (!menuItem.i18nLabelKey) {
                <span class="label" [class.visible]="layoutService.menuExpanded()">{{ menuItem.label }}</span>
              } @else {
                <span class="label" [class.visible]="layoutService.menuExpanded()">{{ i18n?.i18nLng()[menuItem.i18nLabelKey] }}</span>
              }
            </a>
          }
        </ng-container>
      }
    </li>
  }
</ul>

<ng-template #parent let-parentMenu="parentMenu">
  <div [ngClass]="parentMenu?.expanded && parentMenu?.selected ? 'expanded-menu-container' : null">
    <a class="sidebar-menu-link"
       tabindex="0"
       [id]="parentMenu.id"
       [attr.aria-expanded]="parentMenu.expanded"
       [attr.aria-controls]="parentMenu.id"
       [ngClass]="parentMenu.active ? 'active-parent-menu' : null"
       [class.selected]="parentMenu?.selected"
       (click)="activateMenuItem(parentMenu)"
       (keydown)="onKeyDown($event)"
       [pTooltip]="!parentMenu.i18nLabelKey ? parentMenu.label : i18n?.i18nLng()[parentMenu.i18nLabelKey]">
      <i [ngClass]="parentMenu.icon"></i>
      @if (!parentMenu.i18nLabelKey) {
        <span class="label" [class.visible]="layoutService.menuExpanded()">{{ parentMenu.label }}</span>
      } @else {
        <span class="label" [class.visible]="layoutService.menuExpanded()">{{ i18n?.i18nLng()[parentMenu.i18nLabelKey] }}</span>
      }
      @if (layoutService.menuExpanded()) {
        <i class="menu-item-toggle-icon"
           [ngClass]="parentMenu?.expanded ? 'pi pi-angle-up' : 'pi pi-angle-down'"
           [class.selected]="parentMenu?.selected || parentMenu.active">
        </i>
      }
    </a>
    <ul role="menu" [id]="parentMenu.id" [spsChildrenMenuToggler]="parentMenu?.expanded && layoutService.menuExpanded() && !refreshMenuContainer">
      @for (menuItem of parentMenu.items ?? []; track menuItem.id) {
        <li role="none">
          @if (menuItem.type === 'H') {
            <ng-container>
              @if (!menuItem.i18nLabelKey) {
                <span class="menu-header" [class.visible]="layoutService.menuExpanded()">{{ menuItem.label }}</span>
              } @else {
                <span class="menu-header" [class.visible]="layoutService.menuExpanded()">{{ i18n?.i18nLng()[menuItem.i18nLabelKey] }}</span>
              }
            </ng-container>
          }
          @if (menuItem.type.startsWith('S')) {
            <ng-container [ngTemplateOutlet]="childmenu"
                          [ngTemplateOutletContext]="{childMenu: menuItem, expanded: parentMenu?.expanded}">
            </ng-container>
          }
        </li>
      }
    </ul>
  </div>
</ng-template>

<ng-template #childmenu let-childMenu="childMenu" let-visible="expanded">
  <!-- RouterLink Menu-Item -->
  @if (childMenu?.routerLink) {
    <a class="sidebar-menu-link"
       role="menuitem"
       [id]="childMenu.id"
       [tabindex]="(visible && layoutService.menuExpanded() ) ? 0 : -1"
       [routerLink]="childMenu?.routerLink"
       [ngClass]="childMenu.active ? 'active-child-menu' : null"
       [class.selected]="childMenu?.selected"
       (click)="activateMenuItem(childMenu)"
       (keydown)="onKeyDown($event)"
       [pTooltip]="!childMenu.i18nLabelKey ? childMenu.label : i18n?.i18nLng()[childMenu.i18nLabelKey]">
      @if (childMenu.icon) {
        <i [ngClass]="childMenu.icon"></i>
      }
      <!-- for payment-methods = active-indicator -->
      @if (childMenu.type === 'SP') {
        <sps-payment-status
            [status]="childMenu?.data?.status">
        </sps-payment-status>
      }
      <!-- -->
      @if (!childMenu.i18nLabelKey) {
        <span class="label" [class.visible]="layoutService.menuExpanded()">{{ childMenu.label }}</span>
      } @else {
        <span class="label" [class.visible]="layoutService.menuExpanded()">{{ i18n?.i18nLng()[childMenu.i18nLabelKey] }}</span>
      }
    </a>
  }
  <!-- URI Menu-Item -->
  @if (childMenu?.url) {
    <a class="sidebar-menu-link"
       role="menuitem"
       [tabindex]="(visible && layoutService.menuExpanded() ) ? 0 : -1"
       [href]="childMenu?.url"
       [target]="childMenu?.target ? childMenu?.target : null"
       [ngClass]="childMenu.active ? 'active-child-menu' : null"
       [class.selected]="childMenu?.selected"
       (click)="activateMenuItem(childMenu)"
       (keydown)="onKeyDown($event)"
       [pTooltip]="!childMenu.i18nLabelKey ? childMenu.label : i18n?.i18nLng()[childMenu.i18nLabelKey]">
      @if (!childMenu.i18nLabelKey) {
        <span class="label" [class.visible]="layoutService.menuExpanded()">{{ childMenu.label }}</span>
      } @else {
        <span class="label" [class.visible]="layoutService.menuExpanded()">{{ i18n?.i18nLng()[childMenu.i18nLabelKey] }}</span>
      }
      @if (childMenu.icon) {
        <i [ngClass]="childMenu.icon"></i>
      }
    </a>
  }
  <!-- else... -->
  @if (!childMenu?.routerLink && !childMenu?.url) {
    <a class="sidebar-menu-link"
       role="menuitem"
       [tabindex]="visible ? 0 : -1"
       [routerLink]="childMenu?.routerLink ? childMenu.routerLink : null"
       [ngClass]="childMenu.active ? 'active-child-menu' : null"
       [class.selected]="childMenu?.selected"
       (click)="activateMenuItem(childMenu)"
       (keydown)="onKeyDown($event)"
       [pTooltip]="!childMenu.i18nLabelKey ? childMenu.label : i18n?.i18nLng()[childMenu.i18nLabelKey]">
      @if (childMenu.icon) {
        <i [ngClass]="childMenu.icon"></i>
      }
      @if (!childMenu.i18nLabelKey) {
        <span class="label" [class.visible]="layoutService.menuExpanded()">{{ childMenu.label }}</span>
      } @else {
        <span class="label" [class.visible]="layoutService.menuExpanded()">{{ i18n?.i18nLng()[childMenu.i18nLabelKey] }}</span>
      }
    </a>
  }
</ng-template>
